import { api } from './client';

/** Mirrors the anonymous DTOs from FixedAssetsController reports. */
export interface AssetRegisterRow {
  id: number;
  name: string;
  code: string | null;
  status: string;
  assetType: string;
  assetAccount: number;
  acquisitionCost: number;
  accumulatedDepreciation: number;
  netBookValue: number;
  usefulLifeMonths: number;
  acquisitionDate: string;
  lastDepreciationDate: string | null;
  usageSuspendedSince: string | null;
}

export interface AssetRegisterDto {
  assets: AssetRegisterRow[];
  totals: {
    count: number;
    activeCount: number;
    acquisitionCost: number;
    accumulatedDepreciation: number;
    netBookValue: number;
  };
}

export interface DepreciationScheduleRow {
  id: number;
  name: string;
  code: string | null;
  monthlyDepreciation: number;
  remainingAmount: number;
  monthsLeft: number;
  suspended: boolean;
}

export interface AssetMovementRow {
  id: number;
  fixedAssetId: number;
  assetName: string;
  operationType: string;
  operationDate: string;
  amount: number;
  journalEntryId: number | null;
  calculationDescription: string | null;
}

export const assetReportsApi = {
  register: () => api.get<AssetRegisterDto>('/fixed-assets/reports/register'),

  depreciationSchedule: () => api.get<DepreciationScheduleRow[]>('/fixed-assets/reports/depreciation-schedule'),

  movements: (limit = 200) => api.get<AssetMovementRow[]>('/fixed-assets/reports/movements', { limit }),
};
